import RepaymentOptionsConsolidation from 'tio-employee/components/repayment-options/consolidation';

<template><RepaymentOptionsConsolidation class="scroll-smooth" /></template>
